// Enhanced function to find local maxima using both pitch and intensity
export const findLocalMaxima = (pitchSegments, intensitySegments, globalMaxIntensity) => {
  if (pitchSegments.length < 3) return [];
  
  const maxima = [];
  for (let i = 1; i < pitchSegments.length - 1; i++) {
    const prevPitch = pitchSegments[i - 1].pitch;
    const currPitch = pitchSegments[i].pitch;
    const nextPitch = pitchSegments[i + 1].pitch;
    
    // Find corresponding intensity
    const time = pitchSegments[i].time;
    const intensityPoint = intensitySegments.find(seg => Math.abs(seg.time - time) < 0.01);
    const currIntensity = intensityPoint ? intensityPoint.intensity : 0;
    
    // Simple peak detection: higher than neighbors
    if (currPitch > prevPitch && currPitch > nextPitch) {
      // Calculate combined prominence using both pitch and intensity
      const pitchProminence = (currPitch - Math.min(prevPitch, nextPitch));
      const intensityWeight = currIntensity > 0 ? (currIntensity / globalMaxIntensity) : 0;
      
      maxima.push({
        time: pitchSegments[i].time,
        pitch: currPitch,
        intensity: currIntensity,
        prominence: pitchProminence * (1 + intensityWeight * 0.5), // Boost prominence by intensity
        hasStrongIntensity: currIntensity > (globalMaxIntensity * 0.3) // At least 30% of max intensity
      });
    }
  }
  return maxima;
};

// Find inflection points (local minima and maxima) in the tail
export const findInflectionPoints = (tailPoints) => {
  const inflectionPoints = [];
  
  if (tailPoints.length < 3) return inflectionPoints;
  
  for (let i = 1; i < tailPoints.length - 1; i++) {
    const prevPitch = tailPoints[i - 1].pitch;
    const currPitch = tailPoints[i].pitch;
    const nextPitch = tailPoints[i + 1].pitch;
    
    // Local minima
    if (currPitch < prevPitch && currPitch < nextPitch) {
      inflectionPoints.push({
        point: tailPoints[i],
        type: 'minima',
        index: i
      });
    }
    // Local maxima
    else if (currPitch > prevPitch && currPitch > nextPitch) {
      inflectionPoints.push({
        point: tailPoints[i],
        type: 'maxima',
        index: i
      });
    }
  }
  
  return inflectionPoints;
};